import styled from "@emotion/styled";

export const NavigationBar = styled.div`
  height: 44px;
  background: ${p => p.theme.palette.white};
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  border-bottom: 1px solid ${p => p.theme.palette.neutralLight};
`;
